import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

export const icon = css`
  width: ${pxToRem(36)};
  height: ${pxToRem(36)};
`;

export const container = css`
  display: flex;
  justify-content: space-between;
  max-width: ${pxToRem(280)};
  margin: 0 auto;
`;
